import { Component, OnInit } from '@angular/core';
import { CommonFunctionService, UserPOSData } from '../../../services/Common/common-function.service';
import { EmployeeService } from '../../../POS/POSServices/Employees/employee.service';
const _clone = (d) => JSON.parse(JSON.stringify(d));
@Component({
  selector: 'app-pos-sidebar',
  templateUrl: './pos-sidebar.component.html',
  styleUrls: ['./pos-sidebar.component.scss']
})
export class PosSidebarComponent implements OnInit {
  PaygsetUphideshow: boolean = true;
  MerchantKeyId: any;
  resellerno: any;
  rows = [];
  constructor(private service: EmployeeService, private commonfunction: CommonFunctionService) { }

  ngOnInit() {
    this.MenuSetup();
  }

  MenuSetup() {
    this.MerchantKeyId = this.commonfunction.getUserMerchantData().MerchantKeyId;
    this.resellerno = this.commonfunction.getUserMerchantData().ResellerId;
    this.service.getMerchantServicesAndFees(this.MerchantKeyId, this.resellerno).subscribe(result => {
      if (result != null) {
        this.rows = _clone(result);
        this.rows.forEach(element => {
          if (element.ServiceCode == "PayGSetUp" && element.Status == 1) {
            this.PaygsetUphideshow = true;
          }

          if (element.ServiceCode == "PayGSetUp" && element.Status == 0) {
            this.PaygsetUphideshow = false;
          }


        });


      }



    });
  }


}
